module.exports = __webpack_public_path__ + "img/flat-hex.9c1ada95.svg";